/*! Copyright (c) Safe As Milk. All rights reserved. */
class BackToTopButton extends HTMLElement {
    constructor() {
        super();
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.requestToggleVisibility = this.requestToggleVisibility.bind(this);
        this.isVisible = null;
        this.rafPending = false;
    }
    connectedCallback() {
        window.addEventListener("scroll", this.requestToggleVisibility, { passive: true });
        window.addEventListener("resize", this.requestToggleVisibility, { passive: true });
        window.addEventListener("touchmove", this.requestToggleVisibility, { passive: true });
        this.addEventListener("click", this.scrollToTop);
        this.toggleVisibility();
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.requestToggleVisibility);
        window.removeEventListener("resize", this.requestToggleVisibility);
        window.removeEventListener("touchmove", this.requestToggleVisibility);
        this.removeEventListener("click", this.scrollToTop);
    }
    // EXC: coalesce scroll/resize/touchmove into one read per frame
    requestToggleVisibility() {
        if (this.rafPending) return;
        this.rafPending = true;
        requestAnimationFrame((() => {
            this.rafPending = false;
            this.toggleVisibility();
        }));
    }
    toggleVisibility() {
        const {scrollY: scrollY} = window;
        const {innerHeight: innerHeight} = window;
        const isScrolledPastViewport = scrollY > innerHeight;
        // EXC: only touch classList when the visible state actually changes
        if (isScrolledPastViewport === this.isVisible) return;
        this.isVisible = isScrolledPastViewport;
        if (isScrolledPastViewport) {
            this.classList.add("visible");
            this.classList.remove("hidden");
        } else {
            this.classList.remove("visible");
            this.classList.add("hidden");
        }
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
        });
        this.dispatchEvent(new CustomEvent("on:back-to-top-button:clicked"));
    }
}

customElements.define("back-to-top-button", BackToTopButton);
//# sourceMappingURL=back-to-top-button.js.map
